// 参加征文
export const COMPATION = 'https://activity.xueersi.com/advance/summerCamp/#/'
// 抽奖页
export const LOTTERYPAGE = 'https://activity.xueersi.com/advance/summerCampLottery/#/'
// 携程兑换
export const XIECHENG =
  'https://contents.ctrip.com/activitysetupapp/mkt/index/talgift123?allianceid=3192568&sid=6417056'
// 领课
export const GETCOURSE =
  'https://h5.xueersi.com/enter?type=newbpk0&projectId=60af77068b0999fd7cffce55'

// 我的奖品列表
export const MYPRIZEPAGE = 'https://h5.xueersi.com/60b9f526b320fab32e003a43.html'

// 分享海报页
export const SHARE = 'https://app.xueersi.com/summerposter'

// 写作页面
export const WRITEPAGE = 'https://h5.xueersi.com/60d5868fb1eec7ec2050ea2b.html'

export const RIGHTLIST = [
  {
    id: 1,
    title: '天天抽奖',
    desc: '海量好礼等你带回家~',
    img: ''
  },
  {
    id: 2,
    title: '直通南方周末征文活动',
    desc: '名家点评、赴京游学、集结出书',
    img: ''
  },
  {
    id: 3,
    title: '携程旅行专属权益',
    desc: '精选酒店、热门景点门票等优惠',
    img: ''
  }
]
export const XCRIGHTLIST = [
  {
    id: 1,
    title: '中小学生热门',
    desc: '景点5折起',
    img: ''
  },
  {
    id: 2,
    title: '全国品质人气',
    desc: '酒店7折起',
    img: ''
  },
  {
    id: 3,
    title: '口碑亲子团',
    desc: '立减100元',
    img: ''
  }
]

export const share_params = {
  iconUrl: 'https://editor.xesimg.com/tailor/resource/shareimg-1622980677407.png'
}

// 取不到走兜底
export const SOURCEID =
  window._wltfChannel.urlParams.xeswx_sourceid ||
  window._wltfChannel.hotUrlParams.source ||
  window._wltfChannel.urlParams.sourceid ||
  window._wltfChannel.urlParams.sourceId ||
  '623334618'
